import { mailingCommunicationStore } from '@/services/MailingCommunications/store'
import { notifyError, notifyMessage, notifyProblem } from '@/services/notify'
import _cloneDeep from 'lodash/cloneDeep'
import { unitGroupStore } from '@/services/UnitGroup/store'
import { getOwnersList } from '@/services/Roster/Unit/sequences/getOwnersList'

var DEFAULT_FORM_VALUES = {
  communicationID: 0,
  mailingTypeID: 0,
  isLegalCommunication: false,
  description: '',
  communication: null
}

export const methods = {
  async reload() {
    this.loading = true

    this.communicationID = this.$route.params.id

    if (this.isDebug == true) console.debug('communicationID=' + this.communicationID)

    this.formData = { ...DEFAULT_FORM_VALUES }

    this.loadAudienceTypeList()

    try {
      await mailingCommunicationStore
        .dispatch('getCommunicationById', {
          communicationID: this.mailingCommunicationID
        })
        .then(({ result }) => {
          if (result) {
            this.communication = result
          }
        })
    } catch (e) {
      console.debug('error while loading reload communication update method:' + e)
    }

    this.loading = false
  },

  loadAudienceTypeList() {
    console.debug('loadAudienceTypeList...')
    try {
      this.audienceTypeList = [
        { value: '', label: '<-Select an Audience->' },
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
      ]

      if (
        this.ownerIdsSelected !== undefined &&
        this.ownerIdsSelected &&
        this.selectedDeliveryOwners !== undefined &&
        this.selectedDeliveryOwners === 'selected-owners'
      ) {
        this.showSelectedAudience = true
        this.formData.audienceType = 'No'
      } else if (this.communicationID !== undefined && this.communicationID > 0) {
        console.debug('all-owners')
        this.showSelectedAudience = false
        this.formData.audienceType = 'Yes'
      } else {
        this.formData.audienceType = ''
      }

      console.debug('loadAudienceTypeList=' + JSON.stringify(this.audienceTypeList))
    } catch (e) {
      console.debug(e)
    }
  },

  keydownHandler(e) {
    if (e.keyCode === 13) {
      console.debug('selected===' + this.selected)
    }
  },

  async eraseRecipient({ recipient }) {
    if (this.isReadOnly === false && this.hasReadonly === false) {
      const recipientsSelected = this.recipientsSelected
      let tempRecipients = []
      this.ownerIdsSelected = []

      if (recipientsSelected !== undefined && recipientsSelected) {
        for (let a = 0; a < recipientsSelected.length; a++) {
          const tempRecipient = recipientsSelected[a]

          console.debug(JSON.stringify(recipient) + ' - recips - ' + JSON.stringify(tempRecipient))

          if (tempRecipient && tempRecipient !== recipient) {
            tempRecipients.push(tempRecipient)
            this.addSelectedOwnerValues(tempRecipient)
          }
        }
      }

      this.recipientsSelected = tempRecipients

      await this.processSelectHomeowners()
    }
  },

  async eraseRecipient2(recipient) {
    if (this.isReadOnly === false && this.hasReadonly === false) {
      const recipientsSelected = this.recipientsSelected
      let tempRecipients = []
      this.ownerIdsSelected = []

      if (recipientsSelected !== undefined && recipientsSelected) {
        for (let a = 0; a < recipientsSelected.length; a++) {
          const tempRecipient = recipientsSelected[a]

          console.debug(JSON.stringify(recipient) + ' - recips - ' + JSON.stringify(tempRecipient))

          if (tempRecipient && tempRecipient !== recipient) {
            tempRecipients.push(tempRecipient)
            this.addSelectedOwnerValues(tempRecipient)
          }
        }
      }

      this.recipientsSelected = tempRecipients

      await this.processSelectHomeowners()
    }
  },

  async addHomeowner() {
    console.debug('in addHomeowner...' + JSON.stringify(this.recipientsSelected))
    if (this.query !== undefined && this.query && this.query !== '') {
      const isPresent = this.recipientsSelected.filter(f => f === this.query)
      console.debug('this.query=' + JSON.stringify(this.query))
      if (isPresent !== undefined && isPresent[0] !== undefined && isPresent[0]) {
        console.debug('addHomeowners=' + JSON.stringify(this.recipientsSelected))
      } else {
        this.recipientsSelected.push(this.query)
        this.addSelectedOwnerValues(this.query)
        this.processSelectHomeowners(true)
      }
    }

    this.$store.dispatch('communication/saveIsEdit', {
      isEdit: true
    })

    console.debug('this.recipientsSelected=' + JSON.stringify(this.recipientsSelected))
    this.showHomeownerModal = false
  },

  async processHomeowners(showMessage) {
    if (this.formData.audienceType === 'No') {
      await this.processSelectHomeowners(showMessage)
    } else {
      await this.processAllHomeowners(showMessage)
    }
  },

  async processAudienceType(showMessage) {
    if (this.formData.audienceType === 'No') {
      console.debug('select audience types...')
      await this.processSelectHomeowners(showMessage)
      this.showSelectedAudience = true
    } else {
      await this.processAllHomeowners(showMessage)
      this.showSelectedAudience = false
    }
  },

  async processAllHomeowners(showMessage) {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    this.$store.dispatch('communication/saveDeliveryOwners', {
      selectedDeliveryOwners: 'all-owners'
    })

    this.$store.dispatch('communication/saveDeliveryOwnerIDs', {
      selectedDeliveryOwnerIDs: ''
    })

    this.ownerIdsSelected = []

    try {
      const params = {
        communicationID: this.mailingCommunicationID,
        supportMailDelivery: this.mailingType === 'Mail',
        supportEmailDelivery: this.mailingType === 'Email',
        supportSMSDelivery: this.mailingType === 'SMS',
        supportPushDelivery: this.supportPushDelivery,
        isLegalCommunication: this.isLegalCommunication,
        description: this.communicationDescription,
        mailFullDuplex: this.isDuplexParam,
        mailColor: this.isColorParam,
        deliveryDate: this.deliveryDate,
        deliveryAudience: 'all-owners'
      }

      await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
        params,
        done: async ({ detail }) => {
          console.debug('update communication=' + JSON.stringify(detail))
          if (detail && showMessage !== undefined && showMessage && showMessage === true) {
            notifyMessage('Your target audience has been set to all homeowners.')
          }

          this.$store.dispatch('communication/saveDeliveryOwnerIDs', {
            selectedDeliveryOwnerIDs: this.recipientsSelected
          })

          this.$store.dispatch('communication/saveIsEdit', {
            isEdit: true
          })
        }
      })

      loadingComponent.close()
    } catch (e) {
      notifyError('There was a problem setting your target audience to all homeowners.')
    }

    loadingComponent.close()
  },

  async processSelectHomeowners(showMessage) {
    const params = {
      communicationID: this.mailingCommunicationID,
      supportMailDelivery: this.mailingType === 'Mail',
      supportEmailDelivery: this.mailingType === 'Email',
      supportSMSDelivery: this.mailingType === 'SMS',
      supportPushDelivery: this.supportPushDelivery,
      description: this.communicationDescription,
      mailFullDuplex: this.isDuplexParam,
      mailColor: this.isColorParam,
      isLegalCommunication: this.isLegalCommunication,
      deliveryDate: this.deliveryDate,
      deliveryAudience: 'selected-owners'
    }

    this.$store.dispatch('communication/saveDeliveryOwners', {
      selectedDeliveryOwners: 'selected-owners'
    })

    this.$store.dispatch('communication/saveDeliveryOwnerIDs', {
      selectedDeliveryOwnerIDs: this.ownerIdsSelected
    })

    await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
      params,
      done: async ({ detail }) => {
        if (detail) {
          console.debug('update communication=' + JSON.stringify(detail))

          //Save to CommunicationDeliveryOwners table
          const payload = {
            communicationID: detail.communicationID,
            ownerIDs: this.ownerIdsSelected
          }

          console.debug('ownerIDs=...................' + JSON.stringify(payload))

          await mailingCommunicationStore.dispatch('addDeliveryOwners', {
            payload,
            done: async ({ detail }) => {
              this.$store.dispatch('communication/saveIsEdit', {
                isEdit: true
              })

              if (detail) {
                console.debug('update communication=' + JSON.stringify(detail))

                this.communicationID = detail.communicationID

                if (showMessage !== undefined && showMessage && showMessage === true) {
                  notifyMessage('Your target audience was saved for your selected homeowners.')
                }
              }
            }
          })
        }
      }
    })
  },

  addSelectedOwnerValues(value) {
    const owner = this.fullList.filter(owner => {
      try {
        if (owner.label.toLowerCase().includes(value.toLowerCase())) {
          return owner
        }
      } catch (x) {
        console.error(x)
      }
    })

    if (
      owner[0] !== undefined &&
      owner[0].value !== undefined &&
      owner[0].value &&
      owner[0].value > 0
    ) {
      this.ownerIdsSelected.push(owner[0].value)
      console.debug('ownerIdsSelected=' + JSON.stringify(this.ownerIdsSelected))

      this.$store.dispatch('communication/saveDeliveryOwnerIDs', {
        selectedDeliveryOwnerIDs: this.ownerIdsSelected
      })

      this.$store.dispatch('communication/saveIsEdit', {
        isEdit: true
      })
    }
  },

  returnToParent() {
    this.$router.push({
      name: 'communications'
    })
  },

  async loadMailingTypeList() {
    console.debug('loadMailingTypeList...')
    await mailingCommunicationStore.dispatch('getMailingTypeList').then(({ list }) => {
      if (list) {
        this.mailingTypeList = list
        this.formData.mailingTypeID =
          this.communication !== undefined && this.communication && this.communication
            ? this.communication.mailingTypeID
            : 0
        console.debug('loadMailingTypeList...' + this.formData.mailingTypeID)

        if (this.formData.mailingTypeID) {
          this.$store.dispatch('communication/saveMailingTypeID', {
            mailingTypeID: this.formData.mailingTypeID
          })
        }
      }
    })
  },

  changeMailingsByMailType() {
    this.$store.dispatch('communication/saveMailingTypeID', {
      mailingTypeID: this.formData.mailingTypeID
    })

    console.debug(
      'this.mailingTypeID=' +
        JSON.stringify(this.formData.mailingTypeID + ', ' + this.mailingTypeID)
    )
  },

  optionSelected(option) {
    this.selected = option
    this.formData.address = ''
  },

  filterList: function(name) {
    console.debug('in filterList...')

    // String update
    if (this.name !== name) {
      this.name = name
      this.data = []
    } else {
      // no update occurred
      return
    }

    this.isFiltering = true

    if (this.name === '') {
      this.data = this.fullList
    }

    this.data = this.fullList.filter(owner => {
      try {
        if (owner.label.toLowerCase().includes(this.name.toLowerCase())) {
          return true
        }
      } catch (x) {
        console.error(x)
      }

      return false
    })

    this.isFiltering = false
  },

  addUnitFromUnitGroupUnit() {},

  filterOwnerList() {
    console.debug('in filterOwnerList...' + this.filterOwnerBy)
    if (this.filterOwnerBy && this.data) {
      if (this.filterOwnerBy.length === 0) {
        this.data = this.fullList
      } else {
        this.data = this.data.filter(f => {
          try {
            const filterName = f.data.primaryOwner.name
            return filterName.toLowerCase().indexOf(this.filterOwnerBy.toLowerCase()) !== -1
          } catch (x) {
            console.error(x)
          }

          return null
        })
      }
    } else {
      this.data = this.fullList
    }
  },

  filterUnitGroupList() {
    console.debug(
      'in filterUnitGroupList...' + this.filterBy + ', ' + JSON.stringify(this.unitGroupListCopy)
    )
    if (this.filterBy && this.unitList) {
      if (this.filterBy.length === 0) {
        this.unitGroupList = this.unitGroupListCopy
      } else {
        this.unitGroupList = this.unitGroupList.filter(f => f.name.indexOf(this.filterBy) !== -1)
      }
    } else {
      this.unitGroupList = this.unitGroupListCopy
    }
  },

  async loadUnitGroups() {
    await unitGroupStore
      .dispatch('getUnitGroupList', {
        hoaID: this.hoaId
      })
      .then(({ list }) => {
        console.debug('unit group list=' + JSON.stringify(list))
        if (list) {
          this.unitGroupList = list
          this.unitGroupListCopy = list
        }
      })
  },

  async showUnitGroups() {
    this.showUnitGroupUnitModal = true
    await this.loadUnitGroups()
    this.action = 'addunitgroupunit'
  },

  async showHomeowner() {
    this.showHomeownerModal = true
    await this.loadHomeownerOwnerList()
    this.action = 'addunit'
  },

  async addUnitGroupUnitOwner() {
    const unitGroupID = this.selectedUnitGroupID

    console.debug('in addUnitGroupUnitOwner()...' + unitGroupID)

    this.ownerIds = []

    if (!this.checkedRows || this.checkedRows == undefined || this.checkedRows.length === 0) {
      notifyError('No groups have been checked.')
      return
    }

    console.debug('checkedRows===' + JSON.stringify(this.checkedRows))

    try {
      Array.from(this.checkedRows).forEach(element => {
        if (element && element.unitGroupUnits != undefined) {
          if (this.isDebug === true) console.debug('element' + JSON.stringify(element))

          if (element.primaryOwnerID && element.primaryOwnerID != undefined) {
            this.ownerIds.push(element.unitID)
          }

          Array.from(element.unitGroupUnits).forEach(childElement => {
            if (
              childElement != undefined &&
              childElement.unit != undefined &&
              childElement.unit.primaryOwner != undefined
            ) {
              this.query =
                childElement.unit.primaryOwner.name + ' - ' + childElement.unit.address.addressOne
              if (this.query !== undefined && this.query && this.query !== '') {
                const isPresent = this.recipientsSelected.filter(f => f === this.query)
                console.debug('this.query=' + JSON.stringify(this.query))
                if (isPresent !== undefined && isPresent[0] !== undefined && isPresent[0]) {
                  console.debug('addHomeowners=' + JSON.stringify(this.recipientsSelected))
                } else {
                  this.recipientsSelected.push(this.query)
                  this.addSelectedOwnerValues(this.query)
                  this.processSelectHomeowners(true)
                }
              }

              this.$store.dispatch('communication/saveIsEdit', {
                isEdit: true
              })
            }
          })
        }
      })

      this.showUnitGroupUnitModal = false
      this.checkedRows = []

      console.debug('ownerIds===' + JSON.stringify(this.ownerIds))
    } catch (e) {
      notifyProblem(e)
      this.showUnitGroupUnitModal = false
      this.checkedRows = []
    }

    this.showUnitGroupUnitModal = false
    this.checkedRows = []
    this.loading = false
  },

  async addOwner() {
    this.ownerIds = []

    if (!this.checkRowsOne || this.checkRowsOne == undefined || this.checkRowsOne.length === 0) {
      notifyError('No owners have been checked.')
      return
    }

    console.debug('checkRowsOne===' + JSON.stringify(this.checkRowsOne))

    try {
      Array.from(this.checkRowsOne).forEach(element => {
        if (element) {
          if (this.isDebug === true) console.debug('element' + JSON.stringify(element))

          if (
            element.data.primaryOwner != undefined &&
            element.data.primaryOwner.primaryOwnerID != undefined
          ) {
            this.ownerIds.push(element.data.primaryOwner.primaryOwnerID)
          }
          this.query = element.data.primaryOwner.name + ' - ' + element.data.address.addressOne
          if (this.query !== undefined && this.query && this.query !== '') {
            const isPresent = this.recipientsSelected.filter(f => f === this.query)
            console.debug('this.query=' + JSON.stringify(this.query))
            if (isPresent !== undefined && isPresent[0] !== undefined && isPresent[0]) {
              console.debug('addHomeowners=' + JSON.stringify(this.recipientsSelected))
            } else {
              this.recipientsSelected.push(this.query)
              this.addSelectedOwnerValues(this.query)
              this.processSelectHomeowners(true)
            }
          }

          this.$store.dispatch('communication/saveIsEdit', {
            isEdit: true
          })
        }
      })

      this.showHomeownerModal = false

      console.debug('ownerIds===' + JSON.stringify(this.ownerIds))
    } catch (e) {
      notifyProblem(e)
      this.showHomeownerModal = false
      this.checkRowsOne = []
    }

    this.showHomeownerModal = false
    this.loading = false
    this.checkRowsOne = []
  },

  async loadUnits() {
    try {
      const { results: units } = await this.kms.get('/Roster/Unit/List', {
        params: {
          hoaID: this.hoaId,
          includeOwnerContacts: false,
          startRecord: 1,
          recordCount: 10000
        }
      })

      this.unitListCopy = _cloneDeep(units)
      this.unitList = units

      console.debug('unitList===' + JSON.stringify(this.unitList))

      //this.parseUnitRows()
    } catch (e) {
      notifyProblem(e)
    }
  },

  async loadHomeownerOwnerList() {
    try {
      const { list } = await getOwnersList({
        hoaID: this.hoaId
      })

      console.debug('selectedDeliveryOwnerIDs=' + this.selectedDeliveryOwnerIDs)
      console.debug('selectedDeliveryOwners=' + this.selectedDeliveryOwners)

      this.data = list
      this.fullList = list
      this.dataCopy = list

      console.debug('fullList=' + JSON.stringify(this.fullList))
    } catch (e) {
      notifyProblem(e)
    }
  }
}
